<div
    class="navbar-reveal-zone"
    aria-hidden="true"
    (mouseenter)="showHeader()"></div>

<nav
    class="navbar navbar-expand-md bg-black border-bottom border-body"
    data-bs-theme="dark"
    [class.navbar-hidden]="!headerVisible()"
    (mouseenter)="showHeader()"
    (mouseleave)="hideHeaderAfterPointerLeaves()">
    <div class="container-fluid">
        <a class="navbar-brand" href="#">
            <img src="https://portal-dev.fhadvantage.com/assets/img/logo-fha.png" height="50px" alt="Family Health Advantage" />
        </a>
    </div>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        @if(store.isAuthenticated()){
            <div class="navbar-user ms-auto">
                @if(userDisplayName()) {
                    <span class="navbar-user-name">{{ userDisplayName() }}</span>
                }
                <button class="btn btn-black bg-transparent" (click)="logout()">Logout</button>
            </div>
        }
    </div>
</nav>
